import { render } from "./importPositionProducts.vue?vue&type=template&id=942ae4c2&scoped=true"
import script from "./importPositionProducts.vue?vue&type=script&lang=js"
export * from "./importPositionProducts.vue?vue&type=script&lang=js"

import "./importPositionProducts.vue?vue&type=style&index=0&id=942ae4c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942ae4c2"]])

export default __exports__